@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.notification.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.feature.notification.generated.resources/"

internal val Res.string.dialog_action_ok: StringResource by lazy {
      StringResource("string:dialog_action_ok", "dialog_action_ok", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 28),
      ))
    }

internal val Res.string.no_notification: StringResource by lazy {
      StringResource("string:no_notification", "no_notification", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39, 43),
      ))
    }

internal val Res.string.notification: StringResource by lazy {
      StringResource("string:notification", "notification", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83, 36),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("dialog_action_ok", Res.string.dialog_action_ok)
  map.put("no_notification", Res.string.no_notification)
  map.put("notification", Res.string.notification)
}
